import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { Cell, Grid } from 'formlabs-web-components/Grid';
import { Button } from 'formlabs-web-components/Link';
import {
  ProgressTracker,
  StickyContainer
} from 'formlabs-web-components/Navigation';

import Price from '../Price';
import useIsMobile from '../../../hooks/useIsMobile';

import '../ProductDetailPlugin.module.css';

const Navigation = ({ step, steps, back, price, next }) => {
  const [t] = useTranslation();
  const history = useHistory();
  const mobile = useIsMobile(640);
  const stepTitles = steps.map(s => s.progressTitle);

  return (
    <StickyContainer styleName="options-navigation">
      <Grid direction="x" hasContainer gutters="margin">
        {!mobile && (
          <>
            <Cell mediumSize={8} contentAlignment="align-children-middle">
              <Button to={back} color="borderless-blue" arrow="left">
                {t('Back')}
              </Button>
            </Cell>
            <Cell mediumSize={8}>
              <ProgressTracker
                currentStep={step}
                steps={stepTitles}
                back={targetStep => {
                  history.push(steps[targetStep].path);
                }}
              />
            </Cell>
          </>
        )}
        <Cell
          mediumSize={8}
          smallSize={24}
          contentAlignment="align-children-middle"
        >
          <div styleName="total-and-continue">
            <div styleName="right">
              <span>{t('Total')}</span>
              <strong>
                <Price price={price} />
              </strong>
            </div>

            {typeof next === 'string' ? (
              <Button to={next} arrow="right">
                {t('Continue')}
              </Button>
            ) : (
              next
            )}
          </div>
        </Cell>
      </Grid>
    </StickyContainer>
  );
};
export default Navigation;
